var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    fontFamily: "'MyriadPro-Regular'",
    fontSize: "36",
    transform: "translate(22.295 126)"
  }, "Safari"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safari-original-wordmark-a",
    gradientTransform: "matrix(112 0 0 -112 -33069.5 13971)",
    gradientUnits: "userSpaceOnUse",
    x1: "295.835",
    x2: "295.835",
    y1: "124.728",
    y2: "123.889"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#19D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#1E64F0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "64",
    cy: "48.5",
    fill: "url(#safari-original-wordmark-a)",
    r: "47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 6.1V13m0 70.7v6.9m7.3-83.8l-1.2 6.8M57.9 83.2L56.7 90M78.5 8.7l-2.4 6.5M51.9 81.6l-2.4 6.5m7.2-81.3l1.2 6.8m12.2 69.6l1.2 6.8M49.5 8.7l2.4 6.5m24.2 66.4l2.4 6.5M42.9 11.8l3.4 6M81.7 79l3.4 6M36.8 16l4.5 5.3m45.4 54.1l4.5 5.4M31.6 21.2l5.3 4.5m54.2 45.4l5.3 4.4m-69-48.2l6 3.4m61.2 35.4l6 3.4M24.3 33.9l6.5 2.4m66.4 24.2l6.5 2.3M22.4 41l6.8 1.2m69.6 12.3l6.8 1.2m-83.9-7.3h7m70.6 0h7m-83.9 7.3l6.8-1.2m69.6-12.3l6.8-1.2M24.3 62.8l6.5-2.3m66.4-24.2l6.5-2.4M27.4 69.5l6-3.4m61.2-35.4l6-3.4m-69 48.2l5.3-4.4m54.2-45.4l5.3-4.5M36.8 80.8l4.5-5.4m45.4-54.1l4.5-5.3M42.9 85l3.4-6m35.4-61.2l3.4-6M60.3 6.3l.3 3.7m6.8 76.7l.3 3.8M53.1 7.6l.9 3.6m20 74.3l.9 3.7M46.1 10.1l1.6 3.4m32.6 69.8l1.6 3.4m-42.1-73l2.1 3.2m44.2 63l2.1 3.1M34.1 18.5l2.7 2.7m54.4 54.4l2.7 2.7M29.4 24.1l3.1 2.2m63 44.2l3.1 2.1M25.7 30.5l3.4 1.6m69.8 32.5l3.4 1.6M23.2 37.4l3.6 1m74.4 19.9l3.6 1M21.9 44.7l3.8.3m76.6 6.7l3.8.4m-84.2 0l3.8-.4m76.6-6.7l3.8-.3M23.2 59.3l3.6-1m74.4-19.9l3.6-1M25.7 66.2l3.4-1.6m69.8-32.5l3.4-1.6M29.4 72.6l3.1-2.1m63-44.2l3.1-2.2M39.8 83l2.1-3.1m44.2-63l2.1-3.2m-42.1 73l1.6-3.4m32.6-69.8l1.6-3.4M53.1 89.2l.9-3.7m20-74.3l.9-3.6M60.3 90.5l.3-3.8M67.4 10l.3-3.7",
    fill: "none",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 16.2L60 44.5l3.9 3.9z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9 48.4l4.5 4.5 27.7-36.7z",
    fill: "#D01414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 44.5L31.7 80.6l32.2-32.2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 80.6l36.7-27.7-4.5-4.5z",
    fill: "#ACACAC"
  }));
};